<modal-open-point id="modal-completar-pago">
  <div normal>
    <modal-completar-pago></modal-completar-pago>
  </div>
</modal-open-point>

<div class="checkout-wrapper">
  <main class="checkout-main">
    <!-- Products Column -->
    <section class="products-column">
      <div class="section-title">
        <span class="mdi mdi-basket-outline"></span>
        <h2>Productos ({{total}})</h2>
      </div>
      <div class="card glass products-list">
        <lista-productos-view [articulosIn]="articulosconcantidad" [modelo]="'postcheckout'">
        </lista-productos-view>
      </div>
    </section>

    <!-- Payment Column -->
    <aside class="payment-column">
      <div class="section-title">
        <span class="mdi mdi-credit-card-outline"></span>
        <h2>Finalizar Compra</h2>
      </div>

      <!-- Step 1: Decision (If applicable) -->
      <div *ngIf="displayPreMedios" class="card glass decision-card">
        <h3>¿Desea pagar ahora su pedido?</h3>
        <p class="description">Si elige que NO, se tomará como un Pago Diferido para abonar al recibir o retirar.</p>
        <div class="decision-buttons">
          <button class="btn btn-primary" (click)="siPagar()">
            <span class="mdi mdi-check"></span> Pagar ahora
          </button>
          <button class="btn btn-secondary" (click)="noPagar()">
            <span class="mdi mdi-clock-outline"></span> Pago Diferido
          </button>
        </div>
      </div>

      <!-- Step 2: Payment Methods -->
      <div *ngIf="displayMedios" class="payment-methods-section">
        <div *ngIf="mysmedios.length > 0; else nomedios">
          <div class="card glass payment-list-card">
            <h3>Método de Pago</h3>
            <div class="payment-options">
              <div *ngFor="let medio of mysmedios" class="payment-option" [class.selected]="medio.selecionado"
                (click)="activarMediodepago(medio)">
                <div class="checkbox-wrapper">
                  <span class="mdi" [class.mdi-radiobox-marked]="medio.selecionado"
                    [class.mdi-radiobox-blank]="!medio.selecionado"></span>
                </div>
                <div class="payment-text">
                  <span class="name">{{medio.nombre}}</span>
                  <div *ngIf='!ocultarPrecios && beneficiosTrue && medio.fiid == "DLR"'>
                    <span class="balance" *ngIf="conSaldo; else cargandoSaldo">Saldo: <b>{{saldoActual |
                        currency}}</b></span>
                    <ng-template #cargandoSaldo>
                      <span class="balance-loading">{{errorSaldo ? 'Error al obtener saldo' : 'Cargando
                        saldo...'}}</span>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Payment Plans -->
          <div *ngIf="mymedios !== undefined" class="plans-section">
            <div *ngIf="planesDePagoEnPantalla.length > 0; else noPlanes" class="card glass plans-card">
              <h3>Planes de Pago ({{mymedios.nombre}})</h3>
              <div *ngIf="error" class="error-alert-container">
                <div class="error-alert">
                  <span class="mdi mdi-alert-circle"></span> {{error}}
                </div>
                <div class="error-actions">
                  <button (click)="volverAtras()" class="btn btn-outline">
                    <span class="mdi mdi-arrow-left"></span> Volver al inicio
                  </button>
                  <button (click)="cancelarCompra()" class="btn btn-primary btn-cancel">
                    <span class="mdi mdi-cancel"></span> Cancelar Compra
                  </button>
                </div>
              </div>
              <div class="plans-list">
                <div *ngFor="let plan of planesDePagoEnPantalla" class="plan-item" [class.selected]="plan.seleccionado"
                  (click)="activarPlan(plan)">
                  <span class="mdi" [class.mdi-check-circle]="plan.seleccionado"
                    [class.mdi-circle-outline]="!plan.seleccionado"></span>
                  <div class="plan-info">
                    <span class="cuotas">{{plan.cuotas}} cuotas de {{plan.montoCuota | currency}}</span>
                    <span class="plan-name">{{plan.nombre}}</span>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noPlanes>
              <div class="card glass no-plans-card">
                <h3>Planes de Pago</h3>
                <div class="loading-wrapper" *ngIf="cargandoPlanes">
                  <spinner [height]="'40px'" [width]="'40px'"></spinner>
                </div>
                <p *ngIf="!cargandoPlanes">No hay planes disponibles para este método.</p>
                <button *ngIf="!cargandoPlanes" (click)="volverAtras()" class="btn btn-outline">Volver a Home</button>
              </div>
            </ng-template>
          </div>
        </div>

        <ng-template #nomedios>
          <div class="card glass empty-payment-card">
            <span class="mdi mdi-credit-card-off"></span>
            <p>No dispone de medios de pago asociados.</p>
            <button (click)="volverAtras()" class="btn btn-primary">Volver al Home</button>
          </div>
        </ng-template>
      </div>

      <!-- Totals & Checkout Button -->
      <div class="checkout-summary-section" *ngIf="displayMP || displayPago">
        <div class="card glass summary-card">
          <div class="totals-breakdown">
            <div class="row" *ngIf="costoEnvio">
              <span>Subtotal</span>
              <span>{{totales | currency}}</span>
            </div>
            <div class="row" *ngIf="costoEnvio">
              <span>Costo de envío</span>
              <span>{{costoEnvio | currency}}</span>
            </div>
            <div class="row grand-total">
              <span>TOTAL</span>
              <span>{{totales + costoEnvio | currency}}</span>
            </div>
          </div>

          <!-- Mercado Pago Button -->
          <div class="mp-button-container" *ngIf="displayMP">
            <mercadopago-checkout-button [publicKey]="publicKeyMP" [preferenceId]="idcheckoutMercadoPago"
              [amount]="totales + costoEnvio" (onClose)="manejarCierreMP()">
            </mercadopago-checkout-button>
          </div>

          <!-- Direct Payment Button -->
          <button *ngIf="displayPago" class="btn-checkout btn-primary" (click)="pagarYcontinuar()"
            [disabled]="(myPlan==undefined || mymedios==undefined)">
            <span class="mdi mdi-lock-check"></span> Confirmar y Pagar
          </button>
        </div>
      </div>
    </aside>
  </main>
</div>

<mmax-helpfootbar></mmax-helpfootbar>